export enum Themes {
  ALERT = 'alert',
  DEFAULT = 'default',
  INFO = 'info',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
}
